export interface AuditLog {
  id: string;
  createdAt: string;
  createdBy: CreatedBy;
  orgId: number;
  applicationCode: string;
  moduleController: string;
  moduleName: string;
  action: AuditLogAction;
  isSuccess: boolean;
  description: string;
  params?: Record<string, string>;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export enum AuditLogAction {
  Create = "create",
  CreateBulk = "create-bulk",
  Update = "update",
  Delete = "delete",
  Lock = "lock",
  Unlock = "unlock",
  Import = "import",
  Export = "export",
  Approve = "approve",
  Reject = "reject",
  Run = "run",
  SendMail = "send-mail",
  Sync = "sync",
  Assign = "assign",
  SendToApprove = "sendToApprove",
  RunPayroll = "runPayroll",
}
